module.exports = __webpack_public_path__ + "img/visa.94585d29.svg";